import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { OrderEntryWebshopService } from '../webshop/order-entry-webshop.service';

interface IDetailRendererParams extends ICellRendererParams {
  webshopContext?:OrderEntryWebshopService;
}

@Component({
  selector: 'ag-order-entry-document-detail-renderer',
  template: `
    <div class="document-detail row">
      <div class="col-md-4">
        <div class="row col-space-bottom" *ngFor="let doc of params.node.data?.documents">
          <div class="col-md-10 truncate-string">
            <a [href]="params.context.getDocumentUrl(doc, params)" target="_blank"><i class="fa fa-download"></i> {{doc.name}}</a>
          </div>

          <div class="col-md-2 text-center">
            <button class="btn btn-primary btn-minimal btn-sm" (click)="params.context.deleteDocument(doc.type, doc)" *ngIf="doc.deleteAllowed && params.context.editable">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>

        <div class="col-space-top">
          <button class="btn btn-default" translate (click)="params.context.addDocument(params.node.data)" [translateParams]="{ label: params.node.data?.type }" *ngIf="params.node.data?.uploadAllowed && params.context.editable">GA.UPLOADS.UPLOAD_LABEL</button>
        </div>
      </div>

      <div class="col-md-8 local-supplier-info" *ngIf="params.node.data?.comment || params.node.data?.templates?.length">
        <h4 translate>ORDERENTRY.DOCS.LOCAL_SUPPLIER_INFO</h4>

        <div class="clearfix templates" *ngIf="params.node.data?.templates?.length">
          <label translate>GA.GENERAL.TEMPLATE</label>
          <a *ngFor="let template of params.node.data?.templates" [href]="params.context.getDocumentUrl(template, params)" target="_blank">{{template.name}}</a>
        </div>

        <div class="clearfix" *ngIf="params.node.data?.comment">
          <label translate>GA.GENERAL.COMMENTS</label>
          <p>{{params.node.data?.comment}}</p>
        </div>
      </div>
    </div>
  `,
  styleUrls: [ './ag-document-detail-renderer.scss' ]
})
export class AgDocumentDetailRendererComponent implements ICellRendererAngularComp {
  public params!:IDetailRendererParams;

  public agInit(params:IDetailRendererParams):void {
    this.params = params;
  }

  public refresh(params:IDetailRendererParams):boolean {
    this.params = params;
    return true;
  }
}